export const LANG = {
  firstName: {
    en: 'First Name',
    he: 'שם פרטי',
  },
  lastName: {
    en: 'Last Name',
    he: 'שם משפחה',
  },
  mail: {
    en: 'Email',
    he: 'אימייל',
  },
  countyAreaCode: {
    en: 'Country Area code',
    he: 'קוד אזור מדינה',
  },
  linkedIn: {
    en: 'LinkedIn Profile',
    he: 'קישור לפרופיל הלינקדאין',
  },
  areaCode: {
    en: 'area code',
    he: 'קידומת',
  },
  mobile: {
    en: 'Mobile',
    he: 'מספר נייד',
  },
  uploadCV: {
    en: 'Upload CV',
    he: 'העלאת קורות חיים',
  },
  notes: {
    en: 'Notes',
    he: 'הערות',
  },
  iConfirm: {
    en: 'I confirm that my resume will be in your database for future matching',
    he: 'אני מאשר שקורות החיים שלי יהיו במסד הנתונים שלך להתאמה בעתיד',
  },
  submitApplication: {
    en: 'Submit Application',
    he: 'הגשת מועמדות',
  },
  personalInformation: {
    en: 'Personal Information',
    he: 'מידע אישי',
  },
  description: {
    en: 'Description',
    he: 'תיאור',
  },
  requirements: {
    en: 'Requirements',
    he: 'דרישות',
  },
  skills: {
    en: 'Skills',
    he: 'כישורים',
  },
  applyFor: {
    en: 'Apply For this position',
    he: 'להגשת מועמדות למשרה',
  },
  moreDetailsAndApplication: {
    en: 'More details and application',
    he: 'לפרטים נוספים והגשת מועמדות',
  },
  errorFetchingData: {
    en: 'Error fetching data',
    he: 'שגיאה בקבלת נתונים',
  },
  search: {
    en: 'Search',
    he: 'חיפוש',
  },
  selectedItems: {
    en: 'Selected Items',
    he: 'אפשרויות נבחרו',
  },
  regions: {
    en: 'Regions',
    he: 'הישוב שלך',
  },
  tags: {
    en: 'Tags',
    he: 'תגיות',
  },
  totalJobs: {
    en: 'Total Jobs',
    he: 'סך משרות',
  },
  noResults: {
    en: 'No results',
    he: 'אין תוצאות',
  },
  noResultsForSearchProps: {
    en: 'No results were found for your search criteria.',
    he: 'לא נמצאו תוצאות למאפייני החיפוש האלה.',
  },
  close: {
    en: 'Close',
    he: 'סגור',
  },
  jobError: {
    en: 'Job Error',
    he: 'שגיאת משרה',
  },
  jobUnavailiable: {
    en: 'This job is unavailiable',
    he: 'משרה זו אינה זמינה',
  },
  jobInfoError: {
    en: 'Job information error',
    he: 'שגיאה במידע שהתקבל עבור המשרה',
  },
  jobApplySuccess: {
    en: 'Thank You, your application submitted successfully',
    he: 'תודה, המועמדות שלך הוגשה בהצלחה',
  },
  maxFilesError: {
    en: 'Maximum files to upload is ',
    he: 'המקסימום קבצים להעלות הוא ',
  },
  onlyOneFileError: {
    en: 'Only one file can be uploaded',
    he: 'ניתן להעלות קובץ אחד בלבד',
  },
  additionalFiles: {
    en: 'Additional files',
    he: 'קבצים נוספים',
  },
  back: {
    en: 'Back >>',
    he: 'חזרה >>',
  },
  maxFilesSizeError: {
    en: 'Maximum files size to upload is ',
    he: 'לא ניתן להוסיף, גודל סך הקבצים גדול מ- ',
  },
  totalSize: {
    en: 'Total size',
    he: 'גודל כולל',
  },
  privacyPolicy: {
    en: 'Privacy Policy',
    he: 'מדיניות פרטיות',
  },
  privacyPolicyAcceptance: {
    en: 'I approve that I read the',
    he: 'אני מאשר שקראתי את',
  },
} as const;
